<template>
  <div class="w-full h-screen bg-gray-200">
    <div class="m-4 flex flex-col justify-center items-center">
      <h2 class="font-bold">UAT Analysis - Set #34</h2>
    </div>
    <div class="flex flex-col justify-center items-center">
      <div v-for="result in results" :key="result.testSerial"
        class="w-80 bg-white rounded-xl p-2 m-6 flex h-60 divide-x divide-dashed divide-gray-300 shadow-lg">
        <div class="px-2 flex flex-col justify-center items-center">
          Test #{{result.testSerial}}
          <div class="text-sm text-gray-400">{{result.manufacturer}}</div>
        </div>
        <div class="w-20 relative bg-blue-100/50"></div>
        <div class="w-40 h-20 relative flex flex-col bg-blue-100/50">
          <div class="-mt-6 mb-4 text-xs">Control</div>
          <dropdown
            v-model="result.control"
            :options="resultValues">
          </dropdown>
          <div class="mt-4 w-max text-xs text-gray-500">recorded: {{result.controlTime}}</div>
        </div>
        <div class="w-20 relative bg-blue-100/50"></div>
        <div class="w-40 h-20 relative flex flex-col bg-blue-100/50">
          <div class="-mt-6 mb-4 text-xs">Test</div>
          <dropdown
            v-model="result.test"
            :options="resultValues">
          </dropdown>
          <div class="mt-4 w-max text-xs text-gray-500">recorded: {{result.testTime}}</div>
        </div>
        <div class="w-20 relative bg-blue-100/50"></div>
        <div class="w-40 h-20 relative flex flex-col bg-blue-100/50">
          <div class="-mt-6 mb-4 text-xs">Image</div>
          <button v-if="!result.photoTaken" @click="openCamera(result.testSerial)"><v-icon size="34">mdi-image-plus</v-icon></button>
          <canvas class="-mt-4" v-show="result.photoTaken" id="photoTaken" :ref="'canvas-' + result.testSerial" :width="640" :height="360"></canvas>
          <div v-if="result.photoTime" class="mt-2 w-max text-xs text-gray-500">recorded: {{localeTime(result.photoTime)}}</div>
        </div>
      </div>
      <div class="w-80 mx-6 flex justify-items-start">
        <button type="button" class="w-3/4 button text-white" @click="createUatRow">
          <v-icon size="42" color="#888">mdi-card-plus</v-icon>
        </button>
      </div>
    </div>
    <div v-if="modal" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- background overlay -->
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div class="inline-block align-bottom bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div v-if="isCameraOpen">
            <video ref="camera" :width="640" :height="360" autoplay></video>
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot w-full flex m-1 justify-between">
            <div v-if="activeTask > 0" class="flex-initial font-bold mt-2 ml-1 text-lg text-white">Test #{{activeTask}}</div>
            <button type="button" class="w-3/4 button text-white" @click="takePhoto(activeTask)">
              <v-icon size="42" color="#fff">mdi-camera</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '../utils/api'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import Dropdown from '@/components/Dropdown.vue'
import TextField from '@/components/TextField.vue'

dayjs.extend(customParseFormat)

export default {
  components: {
    Dropdown, TextField
  },
  data () {
    return {
      activeTask: 0,
      isCameraOpen: false,
      isLoading: true,
      modal: false,
      results: [
        { testSerial: 4566, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' },
        { testSerial: 4567, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' },
        { testSerial: 4568, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' },
        { testSerial: 4569, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' },
        { testSerial: 4570, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' }
      ],
      resultValues: ['non-reactive', 'reactive', 'weak reactive', 'invalid']
    }
  },
  methods: {
    createCameraElement () {
      this.isLoading = true
      const constraints = (window.constraints = {
				audio: false,
				video: true
			})
      navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false
					this.$refs.camera.srcObject = stream
				})
				.catch(error => {
          this.isLoading = false;
					alert("May the browser didn't support or there is some errors.")
				})
    },
    createUatRow () {
      // get the next serial number
      const newSerial = this.results.slice(-1)[0].testSerial + 1
      this.results.push({ testSerial: newSerial, manufacturer: 'Flowflex', control: '', controlTime: '', test: '', testTime: '', photoTaken: false, photoTime: '' })
    },
    localeTime: function (val) {
      if (val && dayjs(val).isValid()) return dayjs(val).format('HH:mm:ss')
      else return val
    },
    openCamera (taskNum) {
      this.activeTask = taskNum
      this.modal = true
      this.isCameraOpen = true
      this.createCameraElement()
    },
    takePhoto (taskNum) {
      setTimeout(() => {
        this.isShotPhoto = false
      }, 50)
      const context = this.$refs['canvas-' + taskNum][0].getContext('2d')
      context.drawImage(this.$refs.camera, 0, 0, 640, 360)
      this.updateTest(taskNum, 'photoTaken', true)
      this.updateTest(taskNum, 'photoTime', dayjs(new Date()))
      this.modal = false
      this.$refs.camera.srcObject.getTracks().forEach((track) => track.stop())
    },
    updateTest (testRef, property, newVal) {
      const arrIndex = this.results.findIndex((el) => el.testSerial === testRef)
      this.$set(this.results[arrIndex], [property], newVal)
    }
  }
}
</script>
